import {
  useEditMaterialAttribute as useDomainEditMaterialAttribute,
  MaterialsQueryKey,
  MaterialWithRecipesQueryKey
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../common/providers'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

// TODO <HCP-82759>: remove after all add/edit material tabs functionalities
// are moved to the single save button
export const useEditMaterialAttribute = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()
  return useDomainEditMaterialAttribute({
    onError: (error) => {
      notifyIfErrorMessage(
        (error.response?.data as ErrorResponse | undefined)?.message,
        raiseError,
        notify
      )
    },
    onSuccess: () => {
      notify('success', t('success.editMaterial'))
    },
    onSettled: (data, error, variables) => {
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialsQueryKey, variables.plantCode],
        refetchType: 'all'
      })
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialWithRecipesQueryKey, variables.plantCode, variables.materialId],
        refetchType: 'all'
      })
    }
  })
}
